import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/isik-dolgusunun-goz-alti-morluklarina-etkisi/page.tsx");
